import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as assetApi from '../../../../api/assets';
import { denormaliseData, normaliseData } from '../helpers';
import { IAssetTagPayLoad, IPortalPropertyTagModalData, IPortalPropertyTagObj } from '../../../../interfaces/asset';

const useUpdateAssetTag = (nhID: number, selectedTag: IPortalPropertyTagModalData ) => {
    const queryClient = useQueryClient();
    const queryKey = ['asset', 'photos'];

    return useMutation({
        mutationFn: (payload: IAssetTagPayLoad) =>
            assetApi.updateAssetTag(payload),
        onMutate: async (update) => {
            // prevent any query updates while we perform optimistic update
            await queryClient.cancelQueries({ queryKey });

            // copy the current data as it exists in the react-query store
            const [previousKeyAndData]: any[] = queryClient.getQueriesData({
                queryKey
            });

            console.log('previousKeyAndData', previousKeyAndData);

            const oldData = previousKeyAndData?.[1] || [];

            queryClient.setQueriesData({ queryKey }, () => {
                const normalisedData = normaliseData(oldData);
                const propertyTagIDs = normalisedData.properties[nhID].tags;

                const updatedAssetID = update.AssetID.toString();
                let idOfPhotoToMove: number;
                propertyTagIDs.forEach((tagID) => {
                    const tag = normalisedData.tags[tagID];
                    tag.photos = tag.photos.filter((photoID) => {
                        if (photoID.toString() === updatedAssetID) {
                            idOfPhotoToMove = photoID;
                        }
                        return photoID.toString() !== updatedAssetID;
                    });
                });


                if (idOfPhotoToMove) {
                    const idOfTagToMovePhotoTo = propertyTagIDs.find((tagID) => {
                        return normalisedData.tags[tagID].TagID.toString() === update.TagIDs;
                    });

                    if (!idOfTagToMovePhotoTo) {
                        const tagObj: IPortalPropertyTagObj & { photos: number[] }  = {
                            AssetTagID: 0,
                            TagID: selectedTag.TagID, 
                            TagName: selectedTag.TagName, 
                            TagSequence: selectedTag.TagSequence,
                            IsTagPublishWebsite: selectedTag.IsTagPublishWebsite,
                            IsTagPublishPortal: selectedTag.IsTagPublishPortal,
                            IsTagPublishCMS: selectedTag.IsTagPublishCMS,
                            Photo: [],
                            photos: [idOfPhotoToMove]
                        };
                        normalisedData.tags[tagObj.AssetTagID] = tagObj;
                    }

                    const tag = normalisedData.tags[idOfTagToMovePhotoTo || 0];
                    
                    tag.photos = [...tag.photos, idOfPhotoToMove].sort( (photoId1, photoId2) => {
                        return normalisedData.photos[photoId1].PhotoSequence - normalisedData.photos[photoId2].PhotoSequence;
                    });

                }

                return denormaliseData(normalisedData);
            });

            // this gets added to the context in case we need to rollback
            return { previous: oldData };
        },
        onError: (error, _, context) => {
            console.log(error);
            // Rollback to the previous state if mutation fails
            if (context?.previous) {
                queryClient.setQueryData(queryKey, context.previous);
            }
        },
        onSuccess: (data: any) => {
            console.log('data', data);
        },
        onSettled: () => { 
            queryClient.invalidateQueries({
                queryKey
            });
        }
    });
};

export { useUpdateAssetTag };